/***
 * @Authors:
 *      Ashwin Rai (ashwinrai.com)
 *      Nikhil Chougule
 ***/

/*** Imports ***/

/* Library imports */
import React, {Component} from "react";
import PropTypes from "prop-types";

/* Component imports */
import ContentLg from "../../../../ContentLg";
import ConstantsLg from "../../../../ConstantsLg";
import * as UtilityLg from "../../../../UtilityLg";
import TextboxLg from "../../../core/TextboxLg/TextboxLg";

/* Style imports */
import "./styles.css";
import Gutter from "../../../core/Gutter/Gutter";
import LoginFooter from "../../../core/LoginFooter/LoginFooter";
/*** End Imports ***/

class LandingScreen extends Component {
    constructor(props){
        super(props);

        UtilityLg.bindThisToAll(this, "onTxtBxEmailChange", "validate", "showTxtBxEmailAsInvalid",
            "onTxtBxEmailEnter", "txtBxEmailFocusOut"
        );
    }

    componentDidMount () {
        this.TxtBxEmailRef.focusIn();
    }

    onTxtBxEmailChange = (value, respObj) => {
        this.props.onTxtBxEmailChange(value, respObj);
    };

    onTxtBxEmailEnter = (index) => {
        this.props.onTxtBxEmailEnter();
    };

    /* @public method */
    validate = () => {
        this.TxtBxEmailRef.validateManually();
    };

    txtBxEmailFocusOut = () => {
        this.TxtBxEmailRef.focusOut();
    };

    showTxtBxEmailAsInvalid = () => {
        this.TxtBxEmailRef.showAsInvalid();
    };

    onClickChangeUserLoginModal = () => {
        this.props.onClickChangeUserLoginModal();
    };

    render () {
        const {email, emailValidationMsg} = this.props;

        return (
            <div className="recruiter-landing-screen">

                <Gutter height={15}/>

                <div className="rec-ld-sub-hdr">{ContentLg.REC_LANDING_SUB_HDR}</div>

                <Gutter height={20}/>

                <div className="rec-ld-content">
                    <TextboxLg
                        ref = {e=>this.TxtBxEmailRef=e}
                        value = {email}
                        placeholder = {ContentLg.REC_EMAIL_PH}
                        validationMsg = {emailValidationMsg}
                        maxLength = {50}
                        onChange = {this.onTxtBxEmailChange}
                        pattern = {ConstantsLg.REGEX.EMAIL}
                        isRequired = {true}
                        onEnterClick = {this.onTxtBxEmailEnter}
                        autoComplete = {false}
                    />

                    <Gutter height={5} />

                    {
                        this.props.showMessagePublicEmailDomain ?
                            <div style={{
                                    font: 'normal 12px/14px GillSans Italic Regular',
                                    color: '#D0021B'
                                }}
                            >
                                {ContentLg.MSG.PUBLIC_DOMAIN}
                            </div>
                            :
                            <Gutter height={14}/>
                    }
                </div>
                
                <Gutter height={1}/>
                
                <Gutter height={40}/>

                <Gutter height={39}/>

                <div className="rlns-login-btn" onClick={this.onTxtBxEmailEnter}>
                    <div className="rlns-login-btn-content">{ContentLg.BTN.NEXT}</div>
                </div>

                <LoginFooter
                    bottomLayerContent = {ContentLg.BOTTOM_LAYER_FOR_RECRUITER}
                    bottomLayerActionContent = {ContentLg.BOTTOM_LAYER_ACTION_FOR_RECRUITER}
                    gutterHeight = {31}
                    onClickChangeUserLoginModal = {this.props.onClickChangeUserLoginModal}
                />
            </div>
        );
    }
}

LandingScreen.PropTypes = {

};

export default LandingScreen;


// WEBPACK FOOTER //
// ./src/components/RecruiterLogin/components/LandingScreen/LandingScreen.js


// WEBPACK FOOTER //
// ./src/components/RecruiterLogin/components/LandingScreen/LandingScreen.js